import React from "react";
import { FiInbox } from "react-icons/fi";

/**
 * Centered empty state display with optional icon, title, hint, and action.
 *
 * @param {Object} props
 * @param {React.ReactNode} [props.icon] - Optional icon element (default FiInbox).
 * @param {React.ReactNode} props.title - Bold title text.
 * @param {React.ReactNode} [props.hint] - Optional secondary hint text.
 * @param {React.ReactNode} [props.action] - Optional action node (e.g., button).
 * @param {string} [props.className] - Extra classes.
 */
export const EmptyState = ({
  icon,
  title,
  hint,
  action,
  className = ""
}) => {
  const displayIcon = icon !== undefined ? icon : <FiInbox className="w-12 h-12 text-gray-400 mx-auto" />;

  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 ${className}`}>
      {displayIcon && (
        <div className="mb-4">
          {typeof displayIcon === "string" ? (
            <span className="text-gray-400">{displayIcon}</span>
          ) : (
            displayIcon
          )}
        </div>
      )}
      {title && (
        <p className="text-lg font-bold text-gray-700 mb-2 text-center">{title}</p>
      )}
      {hint && (
        <p className="text-sm text-gray-400 mb-4 text-center max-w-xs">{hint}</p>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
};
